import { notification } from 'antd'
import { useTranslations } from 'contexts/Translation'

const useHandleError = () => {
  const { t } = useTranslations()

  const handleError = (err) => {
    notification.error({
      message: t('Something went wrong'),
      description: err.message
    })
  }

  return handleError
}

export default useHandleError
